import { __zcFin, __zcIT, __zcITc, __zcIV, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'

// This schema is a shared source of truth for github-ui (front-end rendering) and
// the github/marketing-hub Next.js app (server-side page config). Some fields below have
// no github-ui consumers today but are read by github/marketing-hub's back-end, so do not
// remove "unused" fields without checking github/marketing-hub first.
export const PageSettingsSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('pageSettings', {
  fields: z.lazy(() =>
    z.object({
      hasMinimalFooter: z.boolean().optional(),
      isHidden: z.boolean().optional(),
      revenuePlay: z.enum(['AI', 'Platform', 'Security']).optional(),
      featureFlag: z.string().nullish(),
      colorMode: z.enum(['light', 'dark']).default('light'),
      globalNavbarStyle: z.enum(['default', 'black', 'dark transparent', 'white', 'light transparent']).optional(),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["colorMode"]];
var __rfz_0=__rf[0]._zod;
function safeParse_PageSettingsSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["hasMinimalFooter"];if(__sv_11!==undefined){if(typeof __sv_11!=="boolean"){_e.push(__zcIT("boolean",__sv_11,["fields","hasMinimalFooter"]));}
}
var __sv_12=__sv_9["isHidden"];if(__sv_12!==undefined){if(typeof __sv_12!=="boolean"){_e.push(__zcIT("boolean",__sv_12,["fields","isHidden"]));}
}
var __sv_13=__sv_9["revenuePlay"];if(__sv_13!==undefined){if(__sv_13!=="AI"&&__sv_13!=="Platform"&&__sv_13!=="Security"){_e.push(__zcIV(["AI","Platform","Security"],__sv_13,["fields","revenuePlay"]));}
}
var __sv_14=__sv_9["featureFlag"];if(__sv_14!==undefined){if(__sv_14!==null){if(typeof __sv_14!=="string"){_e.push(__zcIT("string",__sv_14,["fields","featureFlag"]));}
}
}
var __sv_15=__sv_9["colorMode"];if(__sv_15===undefined){__sv_15=__rf[1]._zod.def.defaultValue;}else{if(__sv_15!=="light"&&__sv_15!=="dark"){_e.push(__zcIV(["light","dark"],__sv_15,["fields","colorMode"]));}
}var __sv_16=__sv_9["globalNavbarStyle"];if(__sv_16!==undefined){if(__sv_16!=="default"&&__sv_16!=="black"&&__sv_16!=="dark transparent"&&__sv_16!=="white"&&__sv_16!=="light transparent"){_e.push(__zcIV(["default","black","dark transparent","white","light transparent"],__sv_16,["fields","globalNavbarStyle"]));}
}
var __o_10={};if(__sv_11!==undefined||("hasMinimalFooter" in __sv_9)){__o_10["hasMinimalFooter"]=__sv_11;}if(__sv_12!==undefined||("isHidden" in __sv_9)){__o_10["isHidden"]=__sv_12;}if(__sv_13!==undefined||("revenuePlay" in __sv_9)){__o_10["revenuePlay"]=__sv_13;}if(__sv_14!==undefined||("featureFlag" in __sv_9)){__o_10["featureFlag"]=__sv_14;}__o_10["colorMode"]=__sv_15;if(__sv_16!==undefined||("globalNavbarStyle" in __sv_9)){__o_10["globalNavbarStyle"]=__sv_16;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_PageSettingsSchema,__zs,null,null);
})()

export type PageSettings = z.infer<typeof PageSettingsSchema>
